import IconTwoGradient, {
	IconTwoGradientProps as _IconTwoGradientProps,
} from './IconTwoGradient';

export { IconTwoGradient };
export type IconTwoGradientProps = _IconTwoGradientProps;
